import { Button, Image } from '@bfe/moly';
import { Modal } from '@web3/base-components';
import { useFm, useHybirdWallet, useParams } from '@web3/base-hooks';
import {
  isApp,
  isMobile,
  newTriggerOneLink,
  switchWalletByApp,
} from '@web3/base-utils';
import cls from 'classnames';
import { appPath } from '@web3/base-utils';
import { useAppVersion } from '@/hooks/appVersion';

import styles from './style.module.scss';

interface IProps {
  isShow: boolean;
  closable?: boolean;
  setIsShow: (params: boolean) => void;
}

export const SwitchModal = ({ isShow, setIsShow, closable = true }: IProps) => {
  const fm = useFm();
  const { openLoginModal, createWallet } = useHybirdWallet();
  const { openAppVersionModal } = useAppVersion();
  const { isLogin, needCreatedCloudWallet } = useHybirdWallet();
  const { locale } = useParams();

  const onCloseModal = () => {
    setIsShow(false);
  };

  const handleSwitchModal = async () => {
    if (isMobile && !isApp()) {
      newTriggerOneLink(window.location.href);
      return;
    }

    // if (isApp()) {
    //   await switchWalletByApp();
    //   onCloseModal();
    //   return;
    // }

    // if (needCreatedCloudWallet) {
    //   createWallet();
    //   return;
    // }

    window.location.href = `/${locale}${appPath}`;

    // openLoginModal();
  };

  const buttonText = (() => {
    if (!isLogin) {
      return fm('connectBybitWallet');
    }

    if (needCreatedCloudWallet) {
      return fm('createWallet');
    }

    return fm('switchWallet');
  })();

  return (
    <Modal
      className={styles.modalBg}
      overlayClassName={styles.modalMask}
      contextWrapper={styles.modalContentWrap}
      open={isShow}
      title=""
      footer={null}
      size="small"
      closable={closable}
      onCancel={onCloseModal}
    >
      <div className={styles.modalContent}>
        <Image
          src={'/bybit/deadpool/image-7f45d8e773054844820ad26dc9065af8.svg'}
          className={styles.icon}
          alt=""
        />
        <h1 className={styles.title}>请先报名</h1>
        {/* <p className={styles.desc}>
          {fm('switchToSupportedNet', {
            walletType: `${fm('bybitMnemonicWallet')}, ${fm('bybitCloudWallet')}, Bybit ${fm('mpcWallet')}`,
          })}
        </p> */}
        <Button
          className={cls('mt-6 w-full')}
          variant="primary"
          size="middle"
          onClick={handleSwitchModal}
        >
          请去首页报名
        </Button>
      </div>
    </Modal>
  );
};
